import React from "react";
import ActionButtons from "../../../utils/ActionButtons";
import "../../../css/pages/user_pages/modals/invoice_edit/LineItemsTable.css";

const LineItemsTable = ({
    items,
    handleItemChange,
    addLineItem,
    deleteLineItem,
    isIGST,
    isGST,
}) => {
    return (
        <>
            <h3>Line Items</h3>
            <div className="line-items-table-container">
                <table className="line-items-table">
                    <thead>
                        <tr>
                            <th>Description</th>
                            <th>Rate Per Unit</th>
                            <th>Quantity</th>
                            { isIGST && (
                                <th>IGST %</th>
                            )}
                            { isGST && (
                                <>
                                    <th>CGST %</th>
                                    <th>SGST %</th>
                                </>
                            )}
                            <th>Actions</th>
                        </tr>
                    </thead>

                    <tbody>
                        {items?.map((item, index) => (
                            <tr key={item.id || index}>
                                <td>
                                    <input
                                        value={item.description || ""}
                                        onChange={(e) =>
                                            handleItemChange(index, "description", e.target.value)
                                        }
                                    />
                                </td>

                                <td>
                                    <input
                                        type="number"
                                        value={item.rate || ""}
                                        onChange={(e) =>
                                            handleItemChange(index, "rate", e.target.value)
                                        }
                                    />
                                </td>

                                <td>
                                    <input
                                        type="number"
                                        value={item.quantity || ""}
                                        onChange={(e) =>
                                            handleItemChange(index, "quantity", e.target.value)
                                        }
                                    />
                                </td>

                                { isIGST && (
                                    <td>
                                        <input
                                            type="number"
                                            value={item.igst_rate || ""}
                                            onChange={(e) =>
                                                handleItemChange(index, "igst_rate", e.target.value)
                                            }
                                        />
                                    </td>
                                )}

                                { isGST && (
                                    <>
                                        <td>
                                            <input
                                                type="number"
                                                value={item.cgst_rate || ""}
                                                onChange={(e) =>
                                                    handleItemChange(index, "cgst_rate", e.target.value)
                                                }
                                            />
                                        </td>

                                        <td>
                                            <input
                                                type="number"
                                                value={item.sgst_rate || ""}
                                                onChange={(e) =>
                                                    handleItemChange(index, "sgst_rate", e.target.value)
                                                }
                                            />
                                        </td>
                                    </>
                                )}

                                <td>
                                    <ActionButtons
                                        actions={[
                                            {
                                                buttonType: "delete",
                                                onClick: () => deleteLineItem(index),
                                            }
                                        ]}
                                    />
                                    {/* <button onClick={() => deleteLineItem(index)}>
                                        Delete
                                    </button> */}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* <button onClick={addLineItem}>+ Add Line Item</button> */}
            <ActionButtons
                actions={[
                    {
                        buttonType: "viewSecondary",
                        customName: "+ Add Line Item",
                        onClick: () => addLineItem,
                    }
                ]}
            />
        </>
    );
};

export default LineItemsTable;
